import IService from '../IService';

export default IService.extend({
  initialize: function () {
    this.cache = null;
    this.cacheTime = 0;
  },

  TYPES: Object.freeze({
    keyword: 'KEYWORD',
    searchQuery: 'SEARCH_QUERY',
  }),

  _getUrl: function () {
    return app.apiUrl('/api/v1/search_recommendations');
  },

  get: function () {
    const deferred = new $.Deferred();
    const curDate = Date.now();

    // from cache
    if (
      this.cache &&
      this.cache.length &&
      this.cacheTime + app.TIME.HOUR >= curDate
    ) {
      deferred.resolve(this.cache);
    } else {
      // from server
      $.ajax({
        url: this._getUrl(),
        cache: true,
        type: 'GET',
        timeout: app.TIME.MINUTE,

        error: (e) => {
          this.cacheTime = 0;
          this.cache = null;
          deferred.reject(e);
        },

        success: (response) => {
          if (_.isArray(response)) {
            this.cacheTime = Date.now();
            this.cache = response;

            deferred.resolve(response);
          } else {
            this.cacheTime = 0;
            this.cache = null;
            deferred.reject();
          }
        },
      });
    }

    return deferred.promise();
  },
});
